export const initPhoneNumbers = () => {
  const container = document.getElementById('phone-numbers-container');
  const addButton = document.getElementById('add-phone-number');
  const template = document.getElementById('phone-number-template');

  if (!container || !addButton || !template) return;

  addButton.addEventListener('click', (e) => {
    e.preventDefault();
    const index = Date.now();
    const html = template.innerHTML.replace(/NEW_RECORD/g, index);
    container.insertAdjacentHTML('beforeend', html);
  });

  container.addEventListener('click', (e) => {
    if (e.target.closest('[data-remove-phone]')) {
      e.preventDefault();
      const row = e.target.closest('[data-phone-row]');
      if (!row) return;

      const destroyInput = row.querySelector("input[name*='[_destroy]']");
      if (destroyInput) {
        destroyInput.value = '1';
        row.style.display = 'none';
      } else {
        row.remove();
      }
    }
  });
};
